import { Outlet } from "react-router-dom";
import Header from "./Header";
// import Footer from "./Footer";
// import classes from './RootLayout.module.css'

function RootLayout({ user }) {
  return (
    <>
      <Header user={user}></Header>
      <main>
        <Outlet />
      </main>
    </>
  );
}

export default RootLayout;
